import PropTypes from "prop-types";
import UiIcon from "./UiIcon";
import "./ui.css";

// One chip per applied filter. Renders nothing when no filter is applied.
export default function FilterChips({ chips, onClearAll }) {
  if (!chips.length) return null;
  return (
    <div className="simcc-chips">
      <span className="simcc-chips__label">Filters</span>
      {chips.map((chip) => (
        <span className="simcc-chip" key={chip.key}>
          <span className="simcc-chip__key">{chip.label}:</span>
          {chip.value}
          <button
            type="button"
            className="simcc-chip__remove"
            aria-label={`Remove ${chip.label} filter`}
            onClick={chip.onRemove}
          >
            <UiIcon name="x" size={10} strokeWidth={2.4} />
          </button>
        </span>
      ))}
      <button type="button" className="simcc-chips__clear" onClick={onClearAll}>
        Clear all
      </button>
    </div>
  );
}

FilterChips.propTypes = {
  chips: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      value: PropTypes.node.isRequired,
      onRemove: PropTypes.func.isRequired,
    })
  ).isRequired,
  onClearAll: PropTypes.func.isRequired,
};
